/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/base/input-box/input-box');
require('components/base/checkbox/checkbox');
require('components/base/form-area/form-area');
require('components/base/drop-menu/drop-menu');
require('components/base/upload/upload')
require('components/common/drop-menu-input/drop-menu-input')
const ajaxHttp = require('appUtil/ajaxHttp.js');
const tip = require('components/base/pop/tip');
const store = require('appVuex/store');

const { apiPath } = require('appService/api');
const { dropMenu: dropMenuEvent,checkbox: checkboxEvent, inputBox: inputBoxEvent,} = require('components/config/event.json');

import generaltopic_img from '../../../../assets/example/generaltopic_img.png'
import generaltopic_detail from '../../../../assets/example/generaltopic_detail.jpg'
import generaltopic_banner from '../../../../assets/example/generaltopic_banner.png'

import activitytopic_img from '../../../../assets/example/activitytopic_img.png'
import activitytopic_detail from '../../../../assets/example/activitytopic_detail.jpg'
import activitytopic_banner from '../../../../assets/example/activitytopic_banner.jpg'

//this.type: 1: 互动   2:资讯   3:活动
const topicAddMinxin = {

  data() {
    return {
      generaltopic_img,
      generaltopic_detail,
      generaltopic_banner,
      activitytopic_img,
      activitytopic_detail,
      activitytopic_banner,
      
      uploadImg: apiPath.common.uploadImg,
      addTopic: apiPath.community.addTopic,
      brandUrl: apiPath.common.carBrand,
      upTopics: apiPath.community.upTopics,
      getTopicInfo: apiPath.community.topicInfo,
      setTopicIsRecommend: apiPath.community.setTopicIsRecommend,
      detailData: {
        brandName:[],
        urlType:1,
        allBrand:'',
        startTime:'',
        endTime:'',
        topicInfo:'',
        location: 1
      },
      iconLoations: [{
        'value':1, 'text': '1'
      },{
        'value':2, 'text': '2'
      },{
        'value':3, 'text': '3'
      },{
        'value':4, 'text': '4'
      },{
        'value':5, 'text': '5'
      },{
        'value':6, 'text': '6'
      }],
      brandList:[],
      allCarValue:'',
      iscanApply:false,
      now: this.formatDate(new Date().getTime()),
      topicRequireOpt:sessionStorage.getItem("topicRequireOpt") || false,
      bannerImgs:JSON.parse(sessionStorage.getItem('bannerTopicImgs')) || {},
      ajaxed:true,
      outlink:'',
      inlink:'',
      isClickType: "",
      imgUrl: "",
      curImgName: "",
      showImgsPosition: false
    }
  },
  computed: {
    /*allCarValue () {
      return this.detailData.allBrand;
    }*/
  },
  route:{
    data(transition){
      ajaxHttp(this.brandUrl)
        .then(res => {
          let _arr =[];
          let _list = res.data;
          _list.map((item) => {
              _arr.push({'value':item.brandId,'text':item.vertifyBrand});
          })
          this.brandList = _arr;
        });
     transition.next();
    },
    waitForData: true
  },
  events: {
    [dropMenuEvent.menu.change](opt){
      let qName = opt.queryName;
      
      if(qName =='location'){
        this.$nextTick(function(){
          this.detailData.location = opt.value
        })
        
      }
    },
    [checkboxEvent.change](val) {
      if (val.queryName === "allBrand"){
        if (this.$refs.allPlatform.value[0] === 0){
          this.detailData.brandName = [];
          this.allCarValue = [0];

          this.brandList.forEach((item) => {
            this.detailData.brandName.push(item.value);//点击全选时, 改变选项状态
          })
        } else {
          this.detailData.brandName = [];
        }
        return;
      }
      if(val.queryName === "canApply"){
        this.iscanApply = val.value[0]
        return;
      }

      if (val.dispatcher.$options._ref === "topicCheckbox"){
        let _val = this.$refs.topicCheckbox.value
        this.detailData.urlType = _val;
        this.detailData.topicInfo = _val==1? this.inlink : this.outlink;
      }
    },
    [inputBoxEvent.change](obj){
      if(obj.queryName == 'topicInfo'){
        this.detailData.topicInfo = obj.value;
        if(this.$refs.topicCheckbox.value==1){
          this.inlink = obj.value;

        }else{
          this.outlink = obj.value;
        }

      }

    }

  },

  methods: {
    _init(){
      if(this.topicRequireOpt){
        this.detailData = JSON.parse(this.topicRequireOpt);
          sessionStorage.removeItem('topicRequireOpt');
          return;
      }

      if(this.$route.params.id) {
        // 编辑状态
        ajaxHttp(this.getTopicInfo,{
          data:{
            id:this.$route.params.id
            }
          })
          .then((rtn) => {
            let data =rtn.data;
            data.startTime = this.formatDate(data.startTime) + ' 00:00:00';
            data.endTime = this.formatDate(data.endTime) + ' 23:59:59';
            var _bn = data.brandName.map(item => { return item*1 })
            data.brandName = _bn;

            data.topicIcon && (this.bannerImgs[data.topicIcon] = {url:data.topicIconUrl,id:data.topicIcon});
            data.banner && (this.bannerImgs[data.banner] = {url:data.bannerUrl,id:data.banner});
            data.topicImgs && (this.bannerImgs[data.topicImgs] = {url:data.topicImgsUrl,id:data.topicImgs});
            data.topicBanner && (this.bannerImgs[data.topicBanner] = {url:data.topicBannerUrl,id:data.topicBanner});

            sessionStorage.setItem("bannerTopicImgs",JSON.stringify(this.bannerImgs));
            //isNeedInfo
            if(data['canApply']){
              data['canApply'] = [data['canApply']];
              this.iscanApply=true;
            }
            if(data['isNeedInfo']){
              data['isNeedInfo'] = [data['isNeedInfo']]
            }
            this.detailData = data;
            }).catch((rtn) => {
              tip(rtn.message)
          })
      }
    },
    imgsPositionFun(cur, name) {   //展示图片位置   img:图标  detail:话题图片  banner:话题页banner
      let _ty = this.type == 1 ? 'generaltopic_' : 'activitytopic_'
      this.imgUrl = this[`${_ty}${cur}`];
      this.curImgName = name;
      this.showImgsPosition = true;
    },
    documentClick() {   //点击空白地方，隐藏图片位置
      this.curImgName = "";
      this.imgUrl = "";
      this.showImgsPosition = false;
    },
    formatDate: function (time) {
      let dTime = new Date(time);
      return `${dTime.getFullYear()}-${dTime.getMonth() + 1}-${dTime.getDate()}`;
    },
    beforeSubmit(queryOpt, vm){
      let argObj = queryOpt;
      if(typeof argObj["canApply"] != "undefined"){
        argObj["canApply"] = argObj["canApply"][0];
      }

      if(typeof argObj["isNeedInfo"] != "undefined"){
        argObj["isNeedInfo"] = argObj["isNeedInfo"][0];
      }

      vm && (vm.queryOpt = argObj);

      this.ajaxed = false;


    },
    loginLose(){
          let that = this;
          tip('登录信息过期');
          window.localStorage.removeItem('appBackToken');
          AB.TOKEN = null;

           let _hash = window.location.hash,
            _idx =_hash.indexOf("/");
            _hash = _hash.substring(_idx);
            if(_hash!="/login" && _hash.indexOf('/page') !=-1){
              sessionStorage.setItem("cbkURL",_hash);
            }

          
          setTimeout(()=>{
            that.$route.router.go({
              path: '/login'
            });
          }, 500);
    },
    formatDatas(){
     this.$refs.formArea._initFormData();
      let _j1= this.detailData;
      let _j2 = this.$refs.formArea.queryOpt;
      let _json={};
      Object.assign(_json,_j1,_j2);

      _json['banner'] = _j2['banner']? _j2['banner']:_j1['banner'];
      _json['topicImgs'] = _j2['topicImgs']? _j2['topicImgs']: _j1['topicImgs'];
      _json['topicBanner'] = _j2['topicBanner']? _j2['topicBanner']: _j1['topicBanner'];
      sessionStorage.setItem("topicRequireOpt",JSON.stringify(_json));



    },
    submit() {
      this.isClickType = "add";
      let url = this.$route.params.id? this.upTopics : this.addTopic;
      this.$refs.formArea.setAction(url).submit();
    },
    recommendFun() {   //推荐
      this.isClickType = "recommend";
      let url = this.$route.params.id? this.upTopics : this.addTopic;
      this.$refs.formArea.setAction(url).submit();
    },
    submitSuccess (rtn) {   //保存成功
      let me = this;
      this.ajaxed = true;
      if(rtn.code==2){
        this.isClickType = "";
        this.formatDatas();
        this.loginLose();
        return;
      }
      if (rtn.code === 0) {
        tip ('保存成功');
        sessionStorage.removeItem("topicRequireOpt");
        
        let topicName = this.type==1? 'bbs-generaltopic' : this.type==2? 'bbs-infotopic' : 'bbs-activitytopic';
        if (this.isClickType == "recommend"){   //保存成功，并推荐该条话题
          let params = {
            id: rtn.data.id,
            isRecommend: 1   //1: 推荐  0: 取消推荐
          }
          ajaxHttp(this.setTopicIsRecommend, {
              type: "post",
              data: params
          }).then((res)=> {
              tip(res.error || "推荐成功");
              setTimeout( () => {
                me.$route.router.go({name:topicName});
              }, 1500)

          }).catch((res)=> {
              tip(res.message);
          })
          return;
        }else {
          setTimeout( () => {
            this.$route.router.go({name:topicName});
          }, 1500)
        }
        
      } else {
        tip (rtn.error)
      }

    },
    goDetails(){

      let _val = this.$refs.topicInput.value;
      if(_val!="" && _val.indexOf('preview')==-1){
        tip("您输入的资讯详情链接地址不正确");
        return;
      }
      this.formatDatas();
      
      if(_val==""){
          this.$route.router.go({name:'detailstopicadd'});
          return;
      }

      
      let idx = 1+_val.lastIndexOf('/');
      let _id = _val.substring(idx);
      this.$route.router.go({name:'detailstopicedit',params:{id:_id}});
    },
    saveEdit(){
      sessionStorage.setItem("topicRequireOpt",JSON.stringify(this.$refs.formArea.queryOpt));
    },
    uploadSuccess(obj,ot){
        this.bannerImgs[obj.data.picId] = {url:obj.data.picPath,id:obj.data.picId};
        sessionStorage.setItem("bannerTopicImgs",JSON.stringify(this.bannerImgs));
     
    },
    setEssenceFn(id,idx, val){ //精华
      let that = this;
      let _val = val==0? 1: 0;
      let args = {
        'postId':id,
        'isBest': _val
      }

      ajaxHttp(this.setEssence, {
          type: "post",
          data: args
      }).then((res)=> {
          this.$refs.tableData.trItems[idx]["elite"] = _val;
      }).catch((res)=> {
          tip(res.message);
      })
    },
  },
  watch: {
    "detailData.brandName"(val, oldVal) {
      let len = this.brandList.length;
      if (val.length == len){
        this.allCarValue = [0];
      } else {
        this.allCarValue = [];
      }
    },
    "detailData.allBrand"(val,oldVal){
      if(typeof val == 'undefined'){
        return;
      }
      if(!!val){
      this.allCarValue = val;
      }
    }
  },
  ready(){
    this._init();
  }
}

module.exports = topicAddMinxin;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/community/community/topicAddMixin.js